import React, { useState } from 'react';

interface userModalProps {
  initialMode: boolean;
  count: number;
}
const useModal = (props: userModalProps) => {
  const { initialMode, count } = props;
  const [modalOpen, setModalOpen] = useState<any>(Array(count).fill(initialMode));
  const setOpenModal = (index: number, state: boolean) => {
    setModalOpen([
      ...modalOpen.slice(0, index),
      state,
      ...modalOpen.slice(index + 1),
    ]);
  };
  const toggle = (index: number) => {
    setModalOpen([
      ...modalOpen.slice(0, index),
      !modalOpen[index],
      ...modalOpen.slice(index + 1),
    ]);
  };
  return {
    modalOpen, setModalOpen, setOpenModal, toggle,
  };
};

export default useModal;
